// #region IMPORT
import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useAppNavigate } from '../../Hooks/back/useAppNavigate';
import { showSnackbar } from '../../Reducer/SnackbarReducer';
/** Components Import */
import { Stack, Box, Typography } from '@mui/material';
import { Button, Combo, Dialog, Checkbox } from '../../Components/MUIs';
import { KakaoPost } from '../../Components/Kakaos';
/** Icons Import */
import { Check as CheckIcon } from '@mui/icons-material';
import Commons from '../../Services/Common/Common';
import {
  StyledLabel,
  StyledTextField,
  comboWrapStyles,
} from '../../Components/Ui/FormStyles';
// #endregion

function Profile(props) {
  // #region 변수
  const dispatch = useDispatch();
  const { inputs, setInputs } = props;
  const { navigate } = useAppNavigate();
  const [kakaoPost, setKakaoPost] = useState(false); // 카카오 지도
  const [isEditingAddress, setIsEditingAddress] = useState(false); // 주소 수정 모드 여부 판단(초기값 false)
  // 회사 검색 (기본값 userInfo)
  const [companySearchText, setCompanySearchText] = useState(
    props.userInfo?.coNm ?? ''
  );
  const [showCompanyResults, setShowCompanyResults] = useState(false);
  const [companySearchLoading] = useState(false);
  const [mokLoading] = useState(false);

  // internalYn === '1' → 외부인 화면 / 그 외 → 내부인 화면
  const isExternal = props.userInfo?.internalYn === '1';
  // #endregion

  // #region 함수
  const checkCapsLock = () => {};
  const HandleMokAuthClick = () => {};

  const HandleCompanySearchChange = (value) => setCompanySearchText(value);

  const HandleSelectSignupCompany = (coCd, coNm = '') => {
    setInputs((prev) => ({
      ...prev,
      coCd: coCd || '',
      coNm: coNm || '',
    }));
    setCompanySearchText(coNm);
    setShowCompanyResults(false);
  };

  const HandleSelectSignupSite = (custCd) => {
    setInputs((prev) => ({ ...prev, custCd: custCd || '' }));
  };

  const GetPostData = (_data) => {
    setInputs((prev) => ({
      ...prev,
      post: _data.road_address.zone_no,
      address1: _data.road_address.address_name,
    }));
  };

  useEffect(() => {
    const isPageReloaded = sessionStorage.getItem('isPageReloaded');

    if (isPageReloaded) {
      // 새로고침이 감지되면 /mypage로 리다이렉트
      navigate('/mypage');
    } else {
      // 새로고침이 아닌 경우, 다음에 새로고침이 감지될 수 있도록 설정
      sessionStorage.setItem('isPageReloaded', 'true');
    }

    // cleanup: 컴포넌트 언마운트시 sessionStorage를 초기화 (다른 페이지 이동 시)
    return () => {
      sessionStorage.removeItem('isPageReloaded');
    };
  }, [navigate]);
  //# endregion

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        boxSizing: 'border-box',
        px: 3,
      }}
    >
      {/* 프로필 사진 */}
      {/* <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          mt: 1,
          mb: 1,
        }}
      >
        <Badge
          overlap="circular"
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          badgeContent={
            <>
              <VisuallyHiddenInput
                type="file"
                accept="image/*"
                id="upload-button"
                onChange={(event) => {
                  const fileList = event.target.files;

                  if (Object.keys(fileList).length === 0) return;

                  const file = fileList[0]; // single file upload

                  const reader = new FileReader();
                  reader.readAsDataURL(file);
                  reader.onload = (e) => {
                    fetch(e.target.result)
                      .then((res) => res.blob())
                      .then((blob) => {
                        const image = new File(
                          [blob],
                          `${new Date()
                            .toISOString()
                            .replace(/T/, '')
                            .replace(/\..+/, '')
                            .replace(/-/g, '')
                            .replace(/:/g, '')}.png`,
                          {
                            type: '/png',
                          }
                        );

                        props.setImageFile({
                          ...props.imageFile,
                          profileFiles: reader.result,
                          profileImage: image,
                          profileFileName: file.name,
                        });
                      });
                  };
                  reader.onerror = (error) => {
                    console.log(error);
                    // 파일 읽기 중 에러가 발생했을 때 실행될 코드
                  };
                }}
              />
              <IconButton
                onClick={() => {
                  document.getElementById('upload-button').click();
                }}
              >
                <SettingsIcon />
              </IconButton>
            </>
          }
        >
          <Badge
            overlap="circular"
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            badgeContent={
              <IconButton
                onClick={() => {
                  props.DeleteLogic2();
                }}
              >
                <CloseIcon />
              </IconButton>
            }
          >
            {props.imageFile.profileFiles ? (
              <Avatar
                sx={{ width: 80, height: 80 }}
                src={props.imageFile.profileFiles}
              />
            ) : (
              <Box
                sx={{
                  width: '80px',
                  height: '80px',
                  padding: '10px',
                  borderRadius: '50%',
                  backgroundColor: 'white',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <img src={avata} width="100%" height="100%" alt="profile" />
              </Box>
            )}
          </Badge>
        </Badge>
      </Box> */}

      {/* 입력 폼 (SignUp 스타일) */}
      <Stack sx={{ my: 3 }} spacing={3}>
        {/* 본인인증 (약관 이후 최상단) */}
        {/* <Box
          sx={{
            p: 2,
            borderRadius: '12px',
            border: '1px solid #E5E7EB',
            backgroundColor: '#F9FAFB',
          }}
        >
          <StyledLabel>본인인증</StyledLabel>
          <Stack direction="row" spacing={1.5} sx={{ mt: 1 }}>
            {inputs.identityConfirm === true ? (
              <Box
                sx={{
                  flex: 1,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: '#ECFDF5',
                  color: '#2CA900',
                  borderRadius: '12px',
                  fontSize: '14px',
                  fontWeight: 500,
                  px: 1.5,
                  height: '48px',
                }}
              >
                본인인증 완료
              </Box>
            ) : (
              <Button
                sx={{
                  flex: 1,
                  backgroundColor: '#1F2937',
                  color: '#FFFFFF',
                  borderRadius: '12px',
                  fontSize: '14px',
                  fontWeight: 500,
                  textTransform: 'none',
                  height: '48px',
                  '&:hover': {
                    backgroundColor: '#374151',
                  },
                }}
                name={mokLoading ? '요청 중...' : '본인인증 시작'}
                disabled={mokLoading}
                onClick={HandleMokAuthClick}
              />
            )}
          </Stack>

          <Typography sx={{ fontSize: '12px', color: '#6B7280', mt: 1 }}>
            본인인증 완료 후 이름·전화번호·생년월일이 자동 입력되며, 동일한
            전화번호가 <strong>로그인 아이디</strong>로 설정됩니다.
          </Typography>
          {inputs.identityErrMsg && (
            <Typography sx={{ fontSize: '13px', color: '#DC2626', mt: 0.5 }}>
              {inputs.identityErrMsg}
            </Typography>
          )}
        </Box> */}

        {/* 이름 */}
        <Box>
          <StyledLabel>이름</StyledLabel>
          <StyledTextField
            fullWidth
            placeholder="본인인증 후 자동 입력"
            value={inputs.userNm}
            onChange={(e) => {
              setInputs({
                ...inputs,
                userNm: e.target.value,
              });
            }}
            onKeyUp={(e) => checkCapsLock(e)}
            disabled
          />
        </Box>

        {/* 전화번호 */}
        <Box>
          <StyledLabel>전화번호 (로그인 ID)</StyledLabel>
          <StyledTextField
            fullWidth
            placeholder="본인인증 후 자동 입력"
            value={inputs.decUserId}
            type="tel"
            disabled
          />
          <Typography
            sx={{
              fontSize: '13px',
              color: '#6B7280',
              mt: 0.75,
              lineHeight: 1.5,
            }}
          >
            로그인 시 사용하는 아이디는 위 본인인증 전화번호와{' '}
            <strong>동일한 번호</strong>입니다. 직접 입력·변경할 수 없으며, 이미
            가입된 번호는 중복 가입할 수 없습니다.
          </Typography>
        </Box>

        {/* 생년월일 (내부만 혈액형) */}
        {isExternal ? (
          <Box>
            <StyledLabel>생년월일</StyledLabel>
            <StyledTextField
              fullWidth
              placeholder="YYYY.MM.DD"
              type="date"
              value={inputs.birth}
              hasValue={!!inputs.birth}
              onChange={(e) => {
                setInputs({
                  ...inputs,
                  birth: e.target.value,
                });
              }}
              disabled
            />
          </Box>
        ) : (
          <Stack direction="row" spacing={2}>
            <Box sx={{ flex: 1 }}>
              <StyledLabel>생년월일</StyledLabel>
              <StyledTextField
                fullWidth
                placeholder="YYYY.MM.DD"
                type="date"
                value={inputs.birth}
                hasValue={!!inputs.birth}
                onChange={(e) => {
                  setInputs({
                    ...inputs,
                    birth: e.target.value,
                  });
                }}
                disabled
              />
            </Box>
            <Box sx={{ flex: 1 }}>
              <StyledLabel>혈액형</StyledLabel>
              <Combo
                name=""
                items={props.bloodList}
                value={inputs.bloodType}
                onChange={(e) => {
                  setInputs({
                    ...inputs,
                    bloodType: e,
                  });
                }}
                fullWidth
                displayEmpty
                renderValue={(value) => {
                  if (!value) {
                    return (
                      <Typography
                        sx={{
                          color: '#9CA3AF',
                          fontSize: '14px',
                        }}
                      >
                        선택
                      </Typography>
                    );
                  }
                  const selectedItem = props.bloodList.find(
                    (item) => item.value === value
                  );
                  return selectedItem ? selectedItem.name : '';
                }}
                wrapSx={comboWrapStyles}
                MenuProps={{
                  PaperProps: {
                    style: {
                      maxHeight: 200,
                    },
                  },
                }}
              />
            </Box>
          </Stack>
        )}

        {/* 주소 (내부 회원만) */}
        {!isExternal && (
          <Box>
            <StyledLabel>주소</StyledLabel>

            {/* 케이스 A: 평상시 (조회 모드) */}
            {!isEditingAddress ? (
              <Stack direction="row" spacing={1.5}>
                <StyledTextField
                  fullWidth
                  placeholder="등록된 주소가 없습니다."
                  // DB에서 가져온 하나의 통 주소(address)를 그대로 보여줌
                  value={inputs.address || ''}
                  disabled
                />
                <Button
                  sx={{
                    minWidth: '100px',
                    backgroundColor: '#1F2937',
                    color: '#FFFFFF',
                    borderRadius: '12px',
                    fontSize: '14px',
                    fontWeight: 500,
                    textTransform: 'none',
                    '&:hover': { backgroundColor: '#374151' },
                  }}
                  name="주소변경"
                  onClick={() => {
                    setIsEditingAddress(true); // 상세 입력 폼 열기
                    Commons.CheckMobileDevice() !== 'ios' && setKakaoPost(true); // 카카오 주소 팝업 바로 띄우기
                  }}
                />
              </Stack>
            ) : (
              /* 케이스 B: 주소변경 버튼을 눌렀을 때 (수정 모드 활성화) */
              <Box>
                {/* 우편번호 & 주소검색 버튼 */}
                <Stack direction="row" spacing={1.5} sx={{ mb: 1.5 }}>
                  <StyledTextField
                    fullWidth
                    placeholder="우편번호"
                    value={inputs.post || ''}
                    onChange={(e) => {
                      setInputs((prev) => ({
                        ...prev,
                        post: e.target.value,
                      }));
                    }}
                    disabled={
                      Commons.CheckMobileDevice() === 'ios' ? false : true
                    }
                  />
                  {Commons.CheckMobileDevice() === 'ios' ? null : (
                    <Button
                      sx={{
                        minWidth: '100px',
                        backgroundColor: '#1F2937',
                        color: '#FFFFFF',
                        borderRadius: '12px',
                        fontSize: '14px',
                        fontWeight: 500,
                        '&:hover': { backgroundColor: '#374151' },
                      }}
                      name="재검색"
                      onClick={() => setKakaoPost(true)}
                    />
                  )}
                </Stack>
                {/* 기본 주소 입력창 (카카오에서 자동 주입) */}
                <StyledTextField
                  fullWidth
                  placeholder="기본 주소"
                  value={inputs.address1 ?? ''}
                  onChange={(e) => {
                    setInputs((prev) => ({
                      ...prev,
                      address1: e.target.value,
                    }));
                  }}
                  sx={{ mb: 1.5 }}
                />

                {/* 상세 주소 입력창 (유저가 직접 타이핑) */}
                <StyledTextField
                  fullWidth
                  placeholder="상세 주소를 입력하세요"
                  value={inputs.address2 ?? ''}
                  onChange={(e) => {
                    setInputs((prev) => ({
                      ...prev,
                      address2: e.target.value,
                    }));
                  }}
                />
              </Box>
            )}
          </Box>
        )}
        {/* 회사 / 사업장 선택 */}
        <Box sx={{ position: 'relative' }}>
          <StyledLabel>회사명</StyledLabel>
          <StyledTextField
            fullWidth
            placeholder="회사명을 입력하세요"
            value={companySearchText}
            onChange={(e) => HandleCompanySearchChange(e.target.value)}
            onFocus={() => setShowCompanyResults(true)}
            onBlur={() => {
              setTimeout(() => setShowCompanyResults(false), 150);
            }}
            disabled
          />
          {companySearchLoading && (
            <Typography sx={{ fontSize: '12px', color: '#6B7280', mt: 0.75 }}>
              검색 중...
            </Typography>
          )}
          {showCompanyResults &&
            companySearchText.trim() &&
            !inputs.coCd &&
            (props.signupCompanyOptions?.length > 0 ? (
              <Box
                sx={{
                  mt: 1,
                  border: '1px solid #E5E7EB',
                  borderRadius: '12px',
                  overflow: 'hidden',
                  bgcolor: '#FFFFFF',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.06)',
                }}
              >
                {props.signupCompanyOptions.map((company) => (
                  <Box
                    key={company.value}
                    onMouseDown={(e) => e.preventDefault()}
                    onClick={() =>
                      HandleSelectSignupCompany(company.value, company.name)
                    }
                    sx={{
                      px: 2,
                      py: 1.5,
                      fontSize: '14px',
                      color: '#1F2937',
                      cursor: 'pointer',
                      borderBottom: '1px solid #F3F4F6',
                      '&:last-child': { borderBottom: 'none' },
                      '&:hover': { bgcolor: '#F9FAFB' },
                      '&:active': { bgcolor: '#F3F4F6' },
                    }}
                  >
                    {company.name}
                  </Box>
                ))}
              </Box>
            ) : (
              !companySearchLoading && (
                <Typography
                  sx={{ fontSize: '12px', color: '#9CA3AF', mt: 0.75 }}
                >
                  검색 결과가 없습니다.
                </Typography>
              )
            ))}
          {inputs.coCd && inputs.coNm && (
            <Typography sx={{ fontSize: '12px', color: '#2CA900', mt: 0.75 }}>
              선택됨: {inputs.coNm}
            </Typography>
          )}
          <Typography sx={{ fontSize: '12px', color: '#6B7280', mt: 1 }}>
            회사명을 입력하면 아래에 목록이 표시됩니다. 선택 후 사업장을 골라
            주세요.
          </Typography>
        </Box>

        <Box>
          <StyledLabel>사업장</StyledLabel>
          <Combo
            name=""
            items={props.signupSiteOptions || []}
            value={inputs.custCd ?? ''}
            onChange={(value) => HandleSelectSignupSite(value)}
            fullWidth
            disabled={!inputs.coCd || !props.signupSiteOptions?.length}
            displayEmpty
            renderValue={(value) => {
              if (!value) {
                return (
                  <Typography sx={{ color: '#9CA3AF', fontSize: '14px' }}>
                    {inputs.coCd
                      ? '사업장을 선택하세요'
                      : '회사 검색 후 선택해 주세요'}
                  </Typography>
                );
              }
              return (
                inputs.custNm ||
                (props.signupSiteOptions || []).find(
                  (item) => item.value === value
                )?.name ||
                ''
              );
            }}
            wrapSx={comboWrapStyles}
            MenuProps={{
              PaperProps: {
                style: {
                  maxHeight: 200,
                },
              },
            }}
          />
        </Box>

        {/* 부서 선택 (내부) / 소속·직위 직접 입력 (외부) */}
        {isExternal ? (
          <>
            <Box>
              <StyledLabel>소속</StyledLabel>
              <StyledTextField
                fullWidth
                placeholder="소속을 입력하세요"
                value={inputs.affiliationNm || ''}
                onChange={(e) => {
                  setInputs({
                    ...inputs,
                    affiliationNm: e.target.value,
                  });
                }}
              />
            </Box>
            <Box>
              <StyledLabel>직위</StyledLabel>
              <StyledTextField
                fullWidth
                placeholder="직위를 입력하세요"
                value={inputs.rank ?? ''}
                onChange={(e) => {
                  setInputs((prev) => ({
                    ...prev,
                    rank: e.target.value,
                  }));
                }}
              />
            </Box>
          </>
        ) : (
          <>
            <Box>
              <StyledLabel>부서 선택</StyledLabel>
              <Combo
                name=""
                items={props.deptOptions || []}
                value={inputs.depCd}
                onChange={(value) => {
                  setInputs({
                    ...inputs,
                    depCd: value,
                  });
                }}
                fullWidth
                disabled={!props.depCd || !props.deptOptions.length}
                displayEmpty
                renderValue={(value) => {
                  if (!value) {
                    return (
                      <Typography
                        sx={{
                          color: '#9CA3AF',
                          fontSize: '14px',
                        }}
                      >
                        선택
                      </Typography>
                    );
                  }
                  const selectedItem = (props.deptOptions || []).find(
                    (item) => item.value === value
                  );
                  return selectedItem ? selectedItem.name : '';
                }}
                wrapSx={comboWrapStyles}
                MenuProps={{
                  PaperProps: {
                    style: {
                      maxHeight: 200,
                    },
                  },
                }}
              />
            </Box>

            <Box>
              <StyledLabel>직위</StyledLabel>
              <StyledTextField
                fullWidth
                placeholder="직위를 입력하세요"
                value={inputs.rank ?? ''}
                onChange={(e) => {
                  setInputs((prev) => ({
                    ...prev,
                    rank: e.target.value,
                  }));
                }}
                disabled={!isExternal}
              />
            </Box>
          </>
        )}

        {/* 회원탈퇴 */}
        <Box sx={{ pt: 1 }}>
          <Button
            sx={{
              color: 'rgba(0,0,0,0.5)',
              fontSize: '15px',
              textTransform: 'none',
              p: 0,
            }}
            variant="text"
            name={'회원탈퇴 >'}
            onClick={() => {
              props.setModalToggle4(true);
            }}
          />
        </Box>

        {/* 저장 */}
        <Button
          fullWidth
          name={'저장'}
          onClick={() => {
            props.SaveLogic1();
          }}
          sx={{
            height: '55px',
            borderRadius: '16px',
            backgroundColor: '#2EBD36',
            color: '#FFFFFF',
            fontSize: '17px',
            fontWeight: 600,
            textTransform: 'none',
            boxShadow: '0 10px 15px -3px rgba(46, 189, 54, 0.25)',
            '&:hover': {
              backgroundColor: '#16A34A',
              boxShadow: '0 10px 15px -3px rgba(46, 189, 54, 0.35)',
            },
          }}
        />
      </Stack>

      <KakaoPost
        open={kakaoPost}
        onClose={() => setKakaoPost(false)}
        title={'주소 검색'}
        ReceivePost={(_data) => GetPostData(_data)}
      />
      {/* 회원 탈퇴 팝업 창 */}
      {props.modalToggle4 && (
        <Dialog
          open={props.modalToggle4}
          titleSx={{ fontSize: 25 }}
          onClose={(e) => props.setModalToggle4(false)}
          contentSx={{
            display: 'flex',
            mb: 2,
          }}
          fullScreen
          title={'탈퇴 안내'}
          content={
            <Box>
              <Typography sx={{ fontSize: 17 }}>
                ㆍ회원탈퇴를 신청하기 전에 안내 사항을 꼭 확인해주세요.
              </Typography>
              <Typography
                sx={{
                  fontSize: 14,
                  mt: 2,
                  ml: 4,
                  fontWeight: 'bold',
                }}
              >
                <CheckIcon />
                사용하고 계신 아이디(
                {Commons.DecryptoAES(props.userInfo.userid)}
                )는 탈퇴할 경우 데이터 재사용 및 복구가 불가능합니다.
              </Typography>
              <Typography
                sx={{
                  fontSize: 14,
                  mt: 2,
                  ml: 4,
                  fontWeight: 'bold',
                }}
              >
                <CheckIcon />
                탈퇴 후 회원정보 및 개인형 서비스 이용기록은 모두 삭제됩니다.
              </Typography>
              <Typography
                sx={{
                  fontSize: 17,
                  mt: 5,
                  mb: 5,
                  color: 'red',
                }}
              >
                ㆍ탈퇴 후에는 아이디{' '}
                {Commons.DecryptoAES(props.userInfo.userid)} 로 다시 가입할 수
                없으며 아이디와 데이터는 복구할 수 없습니다.
                <br />
                ㆍ게시판형 서비스에 남아 있는 게시글은 탈퇴 후 삭제할 수
                없습니다.
              </Typography>
              <Checkbox
                name={'안내 사항을 모두 확인하였으며, 이에 동의합니다.'}
                checked={props.idDelete}
                onChange={(e) => props.setIdDelete(e)}
                nameSx={{
                  fontSize: '16px',
                  mb: 5,
                }}
              />
              <Box sx={{ display: 'flex' }}>
                <Button
                  sx={{
                    marginX: 0.5,
                    width: '100%',
                    borderRadius: 2,
                    backgroundColor: '#E0EAE9',
                    '&:hover': {
                      backgroundColor: '#E0EAE9', // hover 시 배경색
                    },
                    color: '#00602E',
                    fontSize: '15px',
                    padding: '0px, 20px, 0px, 20px',
                  }}
                  size="medium"
                  name={'닫기'}
                  onClick={(e) => {
                    props.setModalToggle4(false);
                  }}
                />
                <Button
                  sx={{
                    marginX: 0.5,
                    width: '100%',
                    borderRadius: 2,
                    backgroundColor: '#2CA900',
                    '&:hover': {
                      backgroundColor: '#2CA900', // hover 시 배경색
                    },
                    color: '#FFFFFF',
                    fontSize: '15px',
                    padding: '0px, 20px, 0px, 20px',
                  }}
                  size="medium"
                  name={'확인'}
                  onClick={(e) => {
                    if (props.idDelete) {
                      props.DeleteLogic1();
                    } else {
                      dispatch(
                        showSnackbar({
                          message: '탈퇴 안내를 확인하고 동의하세요.',
                          type: 'warning',
                        })
                      );
                    }
                  }}
                ></Button>
              </Box>
            </Box>
          }
          fullWidth
          saveButtonName={'확인'}
          closeButtonName={'닫기'}
          useSaveButton={false}
          useSaveAfterClose={false}
          maxWidth="md"
          onSave={(e) => {
            if (props.idDelete) {
              props.DeleteLogic1();
            } else {
              dispatch(
                showSnackbar({
                  message: '탈퇴 안내를 확인하고 동의하세요.',
                  type: 'warning',
                })
              );
            }
          }}
        />
      )}
    </Box>
  );
}

export default Profile;
